import { ReactNode } from 'react'
import { cn } from 'app/lib/utils'

export type EmptyStateProps = {
  /** Optional icon rendered above the title (sized/colored by the caller). */
  icon?: ReactNode
  title: string
  description?: string
  /** Optional call-to-action (e.g. a create button). */
  action?: ReactNode
  className?: string
}

/** Centered dashed-border card for empty lists: icon, title, hint, optional CTA. */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        `flex flex-col items-center justify-center rounded-md border border-dashed border-strong bg-surface px-6 py-14 text-center`,
        className,
      )}
    >
      {icon != null && <div className="mb-3 text-minimal">{icon}</div>}
      <div className="text-body-sm font-semibold tracking-tight text-strong">{title}</div>
      {description != null && <p className="mt-1 max-w-md text-body-sm text-subtle">{description}</p>}
      {action != null && <div className="mt-4">{action}</div>}
    </div>
  )
}
